import script from "./CRM03_034INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM03_034INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__